import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveSeo } from '@/seo/resolve';
import { useSeo } from '@/hooks/useSeo';
import { useJsonLd } from '@/hooks/useJsonLd';

export default function SeoManager() {
  const { pathname } = useLocation();
  const data = useMemo(() => resolveSeo(pathname), [pathname]);

  useSeo(data);
  useJsonLd(data);

  return null;
}